import {writable} from 'svelte/store';

export const isEmbedded = writable<boolean>(false);
export const embeddedWebComponent = writable<boolean>(false);
export const webComponentRoot = writable<HTMLElement>(null);
export const dealMakerUrl = writable<URL>(undefined);
export const apiUrl = writable<URL>(undefined);
export const hostUrl = writable<string>('');
export const embeddedSessionId = writable<string>('');
